import { CreditCard } from 'lucide-react';
import type { GatewayManifestEntry } from '../types';

interface GatewaySelectorProps {
  entries: GatewayManifestEntry[];
  onSelect: (entry: GatewayManifestEntry) => void;
}

/**
 * Only ever rendered when a country's manifest entries number more than
 * one — driven entirely by manifest data, no per-country branching. See
 * the plan's §5/§9. No country is configured with more than one gateway
 * today, so a single entry skips this screen and goes straight to
 * GatewayFactory.
 */
export function GatewaySelector({ entries, onSelect }: GatewaySelectorProps) {
  const ordered = [...entries].sort(
    (a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0)
  );

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4 py-10">
      <div className="w-full max-w-[420px]">
        <h1 className="text-brand-ink mb-5 text-center text-xl font-semibold">
          Choose how you’d like to pay
        </h1>
        <div className="flex flex-col gap-3">
          {ordered.map((entry) => (
            <button
              key={entry.id}
              type="button"
              onClick={() => onSelect(entry)}
              className="bg-brand-deep-blue flex h-[52px] items-center justify-center gap-2 rounded-full px-6 text-[15px] font-medium text-white transition-colors hover:bg-[color-mix(in_srgb,var(--color-brand-deep-blue)_82%,black)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-deep-blue"
            >
              <CreditCard className="h-4 w-4" strokeWidth={2} />
              Pay with {entry.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
